import { IImage, IImageUpdateRequest } from "@/types/image";

export class Image implements IImage {
  public id = 0;
  public site_id = 0;
  public hash = "";
  public extension = "";
  public mime_type = "";
  public name = "";
  public stage_id = 0;
  public memo = "";
  public created_at = "";
  public updated_at = "";
  public url = "";
  public is_published = false;
}

export class ImageUpdateRequest implements IImageUpdateRequest {
  public id = 0;
  public url = "";
  public stage_id = 0;
  public upload_file = "";
  public memo = "";
  public is_published = false;
}
